import { Separator } from "@tellescope/ui";

export const DividerBlock: React.FC = () => {
  return <Separator className="my-2" />;
};
